if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      this.productForm = this.section.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.variantPicker = this.section.querySelector(`variant-picker[data-section="${this.sectionId}"]`);

      this.observer = new IntersectionObserver(([entry]) => {
        this.classList.toggle('sticky-atc--active', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
      });

      this.observer.observe(this.productForm);
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}

